
<div class="modal fade" id="labSampleModal" tabindex="-1" role="dialog" aria-labelledby="viewImage" aria-hidden="true">
  <div class="modal-dialog  modal-xl" role="document">
    <div class="modal-content" style="height: 600px;">
      <button class="no-border-btn doc-close-btn" data-dismiss="modal">
        <img src="../../../assets/images/cross-icon-3.svg" alt="cross-icon" width="24px" height="24px">
      </button>
      <div class="modal-header">
        <div class="row">
          <div class="col-12">
            ID: {{selectedSample.sampleId}} (Current Location: {{selectedSample.sampleDetails?.labCode}})
          </div>
        </div>
      </div>
      <div class="modal-body" style="position:relative;overflow-y: auto; overflow-x: hidden;">
        <div class="row">
          <div class="col-12">
            <table class="table">
                <tbody>
                    <tr style="background:transparent !important;cursor: initial !important;"
                    *ngIf="selectedSample.flag">
                      <td colspan="4" style="position:relative;border:none;">
                        <div class="row">
                          <div class="col-auto content-center pr-0">
                            Parent
                          </div>
                          <div class="col content-center">
                            <hr>
                          </div>
                          <div class="col-auto ml-auto content-center pl-0"
                          (click)="selectedSample.daughterFlag = !selectedSample.daughterFlag;">
                            <img src="../../../assets/images/caret-icon.svg" alt="caret-icon-2"
                            width="24px" height="24px">
                          </div>
                        </div>
                        <div class="row" *ngIf="!selectedSample.daughterFlag">
                          <div class="col-6 stroke-right" 
                          *ngIf="selectedSample.sampleDetails">
                            <div class="details-1-card">
                              <div class="row auto-height-41">
                                <div class="col-6 left">Status:</div>
                                <div class="col-6 right">{{selectedSample.sampleDetails.status}}</div>
                              </div>
                              <div class="row auto-height-41">
                                <div class="col-6 left">Date of collection:</div>
                                <div class="col-6 right">{{selectedSample.sampleDetails.dateCollection|date:'dd/MM/yyyy'}}</div>
                              </div>
                              <div class="row auto-height-41">
                                <div class="col-6 left">Cart ID:</div>
                                <div class="col-6 right">{{selectedSample.sampleDetails.cartId}}</div>
                              </div>
                              <div class="row auto-height-41">
                                <div class="col-6 left">Location:</div>
                                <div class="col-6 right">{{selectedSample.sampleDetails.testLocations}}</div>
                              </div>
                              <div class="row auto-height-41">
                                <div class="col-6 left">Tests assigned:</div>
                                <div class="col-6 right">{{selectedSample.sampleDetails.testAssignedArray}}</div>
                              </div>
                              <div class="row auto-height-41">
                                <div class="col-6 left">Ongoing test:</div>
                                <div class="col-6 right">{{selectedSample.sampleDetails.testOnGoingArray}}</div>
                              </div>
                              <!-- <div class="row auto-height-41">
                                <div class="col-6 left">Current location:</div>
                                <div class="col-6 right">{{selectedSample.sampleDetails.currentLocation}}</div>
                              </div> -->
                            </div>
                          </div>
                          <div class="col-6" style="max-height:378px;overflow-y:auto">
                            <table class="table inner-table">
                              <thead  style="border: 1px solid rgba(61, 72, 86, 0.30);">
                                <tr>
                                  <th scope="col">Tasks</th>
                                  <th scope="col">Location</th>
                                  <th scope="col">Assigned by</th>
                                  <th scope="col">Result </th>
                                </tr>
                              </thead>
                              <tbody  style="border: 1px solid rgba(61, 72, 86, 0.30);">
                                <ng-container *ngIf="selectedSample.sampleDetails && selectedSample.sampleDetails.testAssigned">
                                  <tr *ngFor="let task of selectedSample.sampleDetails.testAssigned">
                                    <td>{{task.testName}}</td>
                                    <td>{{task.testLocation}}</td>
                                    <td>-</td>
                                    <!-- <td>{{task.sampleId}}</td> -->
                                    <td>{{task.result}}</td>
                                  </tr>
                                </ng-container>
                                <ng-container *ngIf="selectedSample.sampleDetails && (selectedSample.sampleDetails.testAssigned == null
                                || selectedSample.sampleDetails.testAssigned.length==0)">
                                  <td colspan="4">There are no task for selected sample</td>
                                </ng-container>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <ng-container *ngIf="selectedSample.sampleDetails && 
                        selectedSample.sampleDetails.daughterDetails && 
                        selectedSample.sampleDetails.daughterDetails.length>0">
                          <ng-container 
                          *ngFor="let daughter of selectedSample.sampleDetails.daughterDetails;let dIndex=index">
                            <div class="row" >
                              <div class="col-auto content-center pr-0">
                                D{{dIndex}}
                              </div>
                              <div class="col content-center">
                                <hr>
                              </div>
                              <div class="col-auto ml-auto content-center pl-0"
                              (click)="selectedSample.daughterFlag = true;daughter.flag = !daughter.flag">
                                <img src="../../../assets/images/caret-icon.svg" alt="caret-icon-2"
                                width="24px" height="24px">
                              </div>
                            </div>
                            <div class="row" *ngIf="daughter.flag">
                              <div class="col-6 stroke-right">
                                <div class="details-1-card">
                                  <div class="row auto-height-41">
                                    <div class="col-6 left">Parent ID:</div>
                                    <div class="col-6 right">{{daughter.parentSampleId}}</div>
                                  </div>
                                  <div class="row auto-height-41">
                                    <div class="col-6 left">Daughter ID:</div>
                                    <div class="col-6 right">{{daughter.sampleId}}</div>
                                  </div>
                                  <div class="row auto-height-41">
                                    <div class="col-6 left">Weight:</div>
                                    <div class="col-6 right" *ngIf="daughter.daughterDetailsAsParent &&
                                    daughter.daughterDetailsAsParent.weight">{{daughter.daughterDetailsAsParent.weight}}</div>
                                    <div class="col-6 right" *ngIf="!daughter.daughterDetailsAsParent || 
                                    (daughter.daughterDetailsAsParent && !daughter.daughterDetailsAsParent.weight)">-</div>
                                  </div>
                                  <div class="row auto-height-41">
                                    <div class="col-6 left">Rem. wt. parent:</div>
                                    <div class="col-6 right">-</div>
                                  </div>
                                  <div class="row auto-height-41">
                                    <div class="col-6 left">Status:</div>
                                    <div class="col-6 right">{{daughter.daughterDetailsAsParent &&
                                      daughter.daughterDetailsAsParent.status ? daughter.daughterDetailsAsParent.status : '-'}}</div>
                                  </div>
                                  <div class="row auto-height-41">
                                    <div class="col-6 left">Date of collection:</div>
                                    <div class="col-6 right">{{daughter.daughterDetailsAsParent.dateOfCollection|date:'dd/MM/yyyy'}}</div>
                                  </div>
                                  <div class="row auto-height-41">
                                    <div class="col-6 left">Cart ID:</div>
                                    <div class="col-6 right">{{daughter.daughterDetailsAsParent &&
                                      daughter.daughterDetailsAsParent.cartId ? daughter.daughterDetailsAsParent.cartId: '-'}}</div>
                                  </div>
                                  <div class="row auto-height-41">
                                    <div class="col-6 left">Location:</div>
                                    <div class="col-6 right overflow-ellipsis">{{daughter.labName}}</div>
                                  </div>
                                  <div class="row auto-height-41">
                                    <div class="col-6 left">Tests assigned:</div>
                                    <div class="col-6 right overflow-ellipsis">{{daughter.testName}}</div>
                                  </div>
                                  <div class="row auto-height-41">
                                    <div class="col-6 left">Ongoing test:</div>
                                    <div class="col-6 right overflow-ellipsis">{{daughter.onGoing}}</div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-6" style="height: 370px; overflow-y: auto;">
                                <table class="table inner-table">
                                  <thead style="border: 1px solid rgba(61, 72, 86, 0.30);">
                                    <tr>
                                      <th scope="col">Tasks</th>
                                      <th scope="col">Location</th>
                                      <th scope="col">Result </th>
                                    </tr>
                                  </thead>
                                  <tbody style="border: 1px solid rgba(61, 72, 86, 0.30);">
                                    <ng-container *ngIf="daughter && daughter.daughterTests && daughter.daughterTests.length>0">
                                      <ng-container *ngFor="let daughterDetails of daughter.daughterTests;">
                                        <tr>
                                          <td>{{daughterDetails.test}}</td>
                                          <td>{{daughterDetails.location}}</td>
                                          <td>{{daughterDetails.result}}</td>
                                        </tr>
                                      </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="(daughter && !daughter.daughterTests) || 
                                    (daughter.daughterTests && daughter.daughterTests.length == 0)">
                                      <tr>
                                        <td colspan="3">There is no daughter details</td>
                                      </tr>
                                    </ng-container>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                      </td>
                    </tr>
                </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="position: absolute; bottom: 0px; right: 0px;">
        <div class="row">
          <div class="col-auto ml-auto">
            <div class="content-center">
            </div>
          </div>
        </div>
      </div>
      <div class="row stick-bottom">
        <div class="col-12 content-center">
          <button class="btn-1 solid-btn" type="button" (click)="addTestPopup(selectedSample)"  data-dismiss="modal">
            Add test
          </button>
        </div>
      </div>
    </div>
  </div>
</div>